import {
  CreateCustomerDto,
  CustomerFilterDto,
  DeleteCustomerDto,
  GetCustomerDto,
  GetCustomerDisplayNamesDto,
  ICustomer,
  ICustomerAutocompleteOption,
  ICustomerDeletionImpact,
  ICustomerListItem,
  ICustomerListResponse,
  UpdateCustomerDto,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class CustomerApi {
  static getCustomers(filter: CustomerFilterDto): Promise<AxiosResponse<ICustomerListResponse>> {
    return AdmiralApi.apiCall<ICustomerListResponse>({
      method: 'POST',
      url: `${BASE_URL}/customer/list`,
      data: filter,
    });
  }

  static getDisplayNames(
    dto: GetCustomerDisplayNamesDto,
  ): Promise<AxiosResponse<ICustomerAutocompleteOption[]>> {
    return AdmiralApi.apiCall<ICustomerAutocompleteOption[]>({
      method: 'POST',
      url: `${BASE_URL}/customer/display-names`,
      data: dto,
    });
  }

  static getCustomer(dto: GetCustomerDto): Promise<AxiosResponse<ICustomerListItem>> {
    return AdmiralApi.apiCall<ICustomerListItem>({
      method: 'POST',
      url: `${BASE_URL}/customer/get`,
      data: dto,
    });
  }

  /** Ermittelt Anbahnungen, Anträge, Schäden, Aufgaben und Kommentare vor dem Löschen. */
  static getDeletionImpact(dto: GetCustomerDto): Promise<AxiosResponse<ICustomerDeletionImpact>> {
    return AdmiralApi.apiCall<ICustomerDeletionImpact>({
      method: 'POST',
      url: `${BASE_URL}/customer/deletion-impact`,
      data: dto,
    });
  }

  static create(dto: CreateCustomerDto): Promise<AxiosResponse<ICustomer>> {
    return AdmiralApi.apiCall<ICustomer>({
      method: 'POST',
      url: `${BASE_URL}/customer/create`,
      data: dto,
    });
  }

  static update(dto: UpdateCustomerDto): Promise<AxiosResponse<ICustomer>> {
    return AdmiralApi.apiCall<ICustomer>({
      method: 'PUT',
      url: `${BASE_URL}/customer/update`,
      data: dto,
    });
  }

  static delete(dto: DeleteCustomerDto): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'DELETE',
      url: `${BASE_URL}/customer`,
      data: dto,
    });
  }
}
